import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/sven/Header";
import { Hero } from "@/components/sven/Hero";
import { TrustBar } from "@/components/sven/TrustBar";
import { Story } from "@/components/sven/Story";
import { Collections } from "@/components/sven/Collections";
import { Marquee } from "@/components/sven/Marquee";
import { Process } from "@/components/sven/Process";
import { FabricLibrary } from "@/components/sven/FabricLibrary";
import { Reviews } from "@/components/sven/Reviews";
import { Booking } from "@/components/sven/Booking";
import { VisitUs } from "@/components/sven/VisitUs";
import { Footer } from "@/components/sven/Footer";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import StoresPage from "@/pages/StoresPage";
import StyleEncyclopediaPage from "@/pages/StyleEncyclopediaPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import { scrollToId } from "@/lib/svenData";
import { Anatomy } from "@/components/sven/Anatomy";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      window.history.replaceState({}, "");
      setTimeout(() => scrollToId(target), 450);
    }
  }, [location.state]);

  return (
    <main>
      <Header />
      <Hero />
      <TrustBar />
      <Story />
      <Collections />
      <Marquee />
      <Process />
      <Anatomy />
      <FabricLibrary />
      <Reviews />
      <Booking />
      <VisitUs />
      <Footer />
    </main>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/stores" element={<StoresPage />} />
          <Route path="/style-guide" element={<StyleEncyclopediaPage />} />
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;